import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { ref, reactive, toRaw, computed } from 'vue'
import { useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import { goBack } from '@/hooks/cosRouter'
import VisitorProgramForm from '../components/VisitorProgramForm.vue'
import { visitorProgramCreateOrUpdate } from '@/api/overseasSales/followUpManage'
import type { FbuVisitorProgramEditParams } from '@/typings/api/followUpManage'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'DcCosOFbuVisitorProgramAdd' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n()
const route = useRoute()

const dataForm = reactive<FbuVisitorProgramEditParams>({
  remindType: 1
})

// 监听是否是从跟进记录页面跳转过来
const querySaleChanceRefId = computed(() => route.query.saleChanceRefId as string)

const fetch = (val: any) => {
  Object.assign(dataForm, val)
}

const visitorProgramFormRef = ref()
const handleReset = () => {
  visitorProgramFormRef.value?.resetFields()
}
const loading = ref(false)
const handleSubmit = () => {
  visitorProgramFormRef.value?.validate().then(() => {
    loading.value = true
    const params = toRaw(dataForm)
    visitorProgramCreateOrUpdate(params)
      .then(() => {
        message.success(t('tips.addSuccess'))
        visitorProgramFormRef.value?.resetFields()
        goBack()
      })
      .finally(() => {
        loading.value = false
      })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_CosLayoutMain = _resolveComponent("CosLayoutMain")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_CosLayoutMain, null, {
    content: _withCtx(() => [
      _createVNode(VisitorProgramForm, {
        ref_key: "visitorProgramFormRef",
        ref: visitorProgramFormRef,
        title: _unref(t)('common.visitorTabs'),
        type: "add",
        value: dataForm,
        "onUpdate:value": [
          _cache[0] || (_cache[0] = ($event: any) => ((dataForm) = $event)),
          fetch
        ],
        saleChanceRefId: querySaleChanceRefId.value
      }, null, 8, ["title", "value", "saleChanceRefId"])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_a_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goBack)()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('btn.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        loading: loading.value,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (handleReset()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('btn.reset')), 1)
        ]),
        _: 1
      }, 8, ["loading"]),
      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
        type: "primary",
        loading: loading.value,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (handleSubmit()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('btn.save')), 1)
        ]),
        _: 1
      }, 8, ["loading"])), [
        [_directive_permission, 'ofbu_visitor_add_btn']
      ])
    ]),
    _: 1
  }))
}
}

})